import { render, staticRenderFns } from "./ClientConsult.vue?vue&type=template&id=796110ab&scoped=true&"
import script from "./ClientConsult.vue?vue&type=script&lang=js&"
export * from "./ClientConsult.vue?vue&type=script&lang=js&"
import style0 from "./ClientConsult.vue?vue&type=style&index=0&id=796110ab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796110ab",
  null
  
)

export default component.exports